import { render, staticRenderFns } from "./PrintDetail.vue?vue&type=template&id=90e8fe3e&"
import script from "./PrintDetail.vue?vue&type=script&lang=ts&"
export * from "./PrintDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PrintDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports